require('./angulartics-google-adwords-remarketing-tag');
module.exports = exports = 'angulartics.google.adwords.remarketing.tag';


//////////////////
// WEBPACK FOOTER
// ./~/angulartics-google-adwords-remarketing-tag/lib/index.js
// module id = 299
// module chunks = 0